import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@nykaa/ui-components';
import { CURRENT_URL, SKIP } from '@nykaa/auth-shared/constants';
import { pushEvent } from '@nykaa/data-layer';
import useAuthData from '@nykaa/auth-shared/hooks/useAuthData';
import { screenType } from '@nykaa/auth-shared/store/constants';
import fetchAuthBanners from '@nykaa/auth-shared/store/actions/authBanners';
import { USER_PORTFOLIO } from '@nykaa/beauty-portfolio-shared/constants';
import { Box, Text } from '@nykaa/glamkit/dist/Layout';
import { platformNames } from 'shared/constants';
import { getSourceFromStorage } from 'layouts/BeautyPortfolio/helpers';
import Widgets from 'components/Widgets';
import { State } from 'store/types';
import { checkCartCouponsUrl } from 'helpers/utils/url';
import {
  getEligibleForVariant,
  getVariantsForPageType,
} from 'helpers/experimentV2';
import { AB_NEW_SHOPPING_BAG } from 'constants/experiments';

const AUTH_PAGE = 'Auth';
const AdPlatformsContainer = styled.div<{ isMan?: boolean; loginBg?: string }>`
  height: 100vh;
  background: ${({ theme: { colors }, isMan, loginBg }) =>
    !isMan ? colors.primary40 : loginBg || colors.surfaceInverse50};
`;

const SkipButton = styled.div`
  z-index: 10;
  position: fixed;
  top: 32px;
  right: 20px;
  color: ${({ theme }) => theme.colors.surface};
  cursor: pointer;
  ${({ theme }) => theme.typography.buttonMedium};
`;
const WidgetContainer = styled.div`
  position: fixed;
  bottom: ${({ newAuth }) => (newAuth ? '415px' : '360px')};
  left: 0;
`;

const AuthBanner = ({ newAuth }: { newAuth?: boolean }) => {
  const isPaginationEnabled = useSelector(
    (state: State) => state.remoteConfig?.switches?.isPaginationEnabled
  );
  const { color } =
    useSelector(
      (state: State) => state.remoteConfig?.configs?.loginBackground
    ) || {};
  const state = useSelector((state: State) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const isMan = __PLATFORM__ === platformNames.MEN;
  const newShoppingBagEnabled =
    useSelector((state: State) =>
      getEligibleForVariant(state, AB_NEW_SHOPPING_BAG, 'A')
    ) || false;
  const variants = getVariantsForPageType(
    state,
    screenType.MWEB_WELCOME_SCREEN
  );

  const {
    authWidget: widget,
    remainingInventeryIds,
    queryParamsObject,
    steps: authStateSteps,
  } = useAuthData();

  useEffect(() => {
    fetchAuthBanners({
      isPaginationEnabled,
      params: {
        page_type: screenType.MWEB_WELCOME_SCREEN,
        ...variants,
      },
      store: __PLATFORM__,
    })(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPaginationEnabled, dispatch]);

  const handleSkip = () => {
    pushEvent('login_skip_click');
    const previousPageUrl = window.localStorage.getItem(CURRENT_URL);
    if (previousPageUrl) {
      const hasBPUrl = previousPageUrl.includes(USER_PORTFOLIO);
      if (checkCartCouponsUrl(previousPageUrl, newShoppingBagEnabled)) {
        window.history.back();
        return;
      }
      const bpEntryUrl = getSourceFromStorage();
      history.go(-authStateSteps?.length);
      history.listen(() => {
        if (
          window.location &&
          window.location.pathname &&
          !window.location.pathname.includes('/auth')
        ) {
          window.location.reload();
        }
      });
      window.location.replace(hasBPUrl ? bpEntryUrl : previousPageUrl);
    } else {
      window.location.replace('/');
    }
  };
  return (
    <>
      <AdPlatformsContainer
        isMan={isMan}
        loginBg={color}
      >
        {newAuth ? (
          <Box
            sx={{ position: 'fixed', top: '12px', right: '20px', zIndex: 10 }}
            onClick={handleSkip}
          >
            <Box
              bgColor="bg-surface-blanket"
              padding={'sm md'}
              cornerRadius="brand"
            >
              <Text
                textColor="bg-surface-default"
                textStyle="base-body-strong"
                role="button"
              >
                Skip
              </Text>
            </Box>
          </Box>
        ) : (
          <SkipButton
            onClick={handleSkip}
            role="button"
          >
            {SKIP}
          </SkipButton>
        )}
        <WidgetContainer newAuth={newAuth}>
          <Widgets
            widgets={widget}
            pageName={AUTH_PAGE}
            remainingInventoryIds={remainingInventeryIds}
            queryParamsObject={queryParamsObject}
          />
        </WidgetContainer>
      </AdPlatformsContainer>
    </>
  );
};
export default AuthBanner;
